
$(function(){
  $('.slick-slide').matchHeight();

  $(".flexnav").flexNav();

  var slider_list = [];
  $('.center-slick').each( function(ind, val){
    slider_list[ind] = $(val).slick({
        infinite: true,
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '0%'
            }
        }]
    });
  });

  $('.company-information-header').click(function(){
    var head = this;
    var head_index = -1;
    $('.company-information-header').each( function( ind, val ){
      if( head == val ){
        head_index = ind;
      }
    });

    if( head_index != -1 ) {
      slider_list[head_index].css('opacity',0);
      slider_list[head_index].animate({'z-index':1},300,function(){
          slider_list[head_index].slick('setPosition');
          slider_list[head_index].animate({'opacity':1});
      });
    }
  });


  $('.origin-pagenav').find('a').click(function(e){
    e.preventDefault();
    if( !$(this).hasClass('active') ){
      var target_page = $(this).text();

      //  開きっぱなしのクラスターを閉じる
      $('.company-information-header').each(function(i, d){
        if( !$(d).find('.company-information_icon').hasClass('active') ) {
          $(d).trigger('click');
        }
      });
      //  対象のクラスターページをアクティブにし他のアクティブを消す
      $('.cluster-table').each(function(i, d){
        $(d).removeClass('active');
        if( $(d).attr('id') == 'cluster-page-'+target_page ) {
          $(d).addClass('active');
        }
      });
      //  ページャーのカレント位置を変える
      $('.origin-pagenav').find('a').each(function(i, d){
        $(d).removeClass('active');
        if( $(d).text() == target_page ) {
          $(d).addClass('active');
        }
      });
    }
  });

    $('.latest-tabs__tab--link').click(function(e){
        e.preventDefault();

        if( ! $(e).hasClass('active') ) {
            $('.latest-tabs__tab').each( function(i, d){
                $(d).removeClass('active');
            });
            $('.latest-tabs__pane').each( function(i, d){
                $(d).removeClass('active');
                $(d).removeClass('in');
            });

            var target = $(this).attr('href');
            $(this).parent('li').addClass('active');
            $('.tab-content').find( target ).addClass('active');
            $('.tab-content').find( target ).addClass('in');
        }


    });

   $('.slide-link').click(function() {
      // スクロールの速度
      var speed = 400; // ミリ秒
      // アンカーの値取得
      var href= $(this).attr("href");
      // 移動先を取得
      var target = $(href == "#" || href == "" ? 'html' : href);
      // 移動先を数値で取得
      var position = target.offset().top;
      // スムーススクロール
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
   });

  $(document).ready(function(){

    $('.nmc_search_keyword__input').each(function(index, input){
      $(input).autocomplete({
        source: $(input).attr('data-endpoint'),
        delay: 500,
        focus: function(){
          return false;
        },
        select: function (event, ui) {
            if ( ui.item.value ) {
                $(input).val(ui.item.value);
                $(input).text(ui.item.lavel);
                return false;
            }
        }
      });
    });

//    $(".search-area ul input:checkbox").change(function(){
//        if ($(this).is(':checked')) {
//            $(this).closest( 'li' ).find("input:checkbox").attr('checked', 'checked');
//        }
//        else {
//            $(this).closest( 'li' ).find("input:checkbox").removeAttr('checked');
//            $(this).parents('li').each(function(){
//                $(this).children('input:checkbox').removeAttr('checked');
//            });
//        }
//    });

  });

});
